<!-- eslint-disable vue/no-mutating-props -->
<template>

 


<div class="nk-block-head">
  <div class="nk-block-head-content">
    <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Kişi  Ekle</h5>
    <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Kişi  Düzenleme</h5>
    <div class="nk-block-des"><p>Kişiler</p></div>
  </div>
</div>

  <form @submit.prevent="gonder">

    <div class="row">
   
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.adsoyad }">
        <div class="col-lg-3">
          <label for="adsoyad" class="form-label">Ad Soyad</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="adsoyad" v-model="localFormData.adsoyad" >
        <span v-if="formHatalar.adsoyad" class="error">{{ formHatalar.adsoyad }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.telefon }">
        <div class="col-lg-3">
          <label for="telefon" class="form-label">Telefon</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="telefon" v-model="localFormData.telefon" >
        <span v-if="formHatalar.telefon" class="error">{{ formHatalar.telefon }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.email }">
        <div class="col-lg-3">
          <label for="email" class="form-label">E-mail</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="email" v-model="localFormData.email" >
        <span v-if="formHatalar.email" class="error">{{ formHatalar.email }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.adres }">
        <div class="col-lg-3">
          <label for="adres" class="form-label">Adres</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="adres" v-model="localFormData.adres" >
        <span v-if="formHatalar.adres" class="error">{{ formHatalar.adres }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.not }">
        <div class="col-lg-3">
          <label for="not" class="form-label">Not</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="not" v-model="localFormData.not" >
        <span v-if="formHatalar.not" class="error">{{ formHatalar.not }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.gorev }">
        <div class="col-lg-3">
          <label for="gorev" class="form-label">Görev</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="gorev" v-model="localFormData.gorev" >
        <span v-if="formHatalar.gorev" class="error">{{ formHatalar.gorev }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.dil }">
        <div class="col-lg-3">
          <label for="dil" class="form-label">Konuştuğu Dil</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="dil" v-model="localFormData.dil" >
        <span v-if="formHatalar.dil" class="error">{{ formHatalar.dil }}</span>
        </div>
      </div>
    
    
    
    

      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.firma }">
        <div class="col-lg-3">
          <label for="firma" class="form-label">Firma</label> 
        </div>
        <div class="col-lg-9">
          <v-select
          v-model="localFormData.firma"
          :options="firmalar"
          label="unvan"
          :reduce="firma => firma.id"
          placeholder="Firma Seçin"
        />
        <span v-if="formHatalar.firma" class="error">{{ formHatalar.firma }}</span>
        </div>
      </div>

    


    

      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.etkinlik }">
        <div class="col-lg-3">
          <label for="etkinlik" class="form-label">Etkinlik</label> 
        </div>
        <div class="col-lg-9">
          <v-select
          v-model="localFormData.etkinlik"
          :options="etkinlikler"
          label="ad"
          :reduce="etkinlik => etkinlik.id"
          placeholder="Etkinlik Seçin"
        />
        <span v-if="formHatalar.etkinlik" class="error">{{ formHatalar.etkinlik }}</span>
        </div>
      </div>

    
    
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.gorsel }"> 
      <label  class="form-label">Profil</label> 
        <picture-input 
          ref="profil"
          width="600" 
          height="200" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Görsel</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="gorselDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.gorsel" class="error">{{ formHatalar.gorsel }}</span>
   
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartviziton }"> 
      <label  class="form-label">Kartvizit Ön</label> 
        <picture-input 
          ref="profil"
          width="600" 
          height="200" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Kartvizit Ön Görseli</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="kartvizitonDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.kartviziton" class="error">{{ formHatalar.kartviziton }}</span>
   
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartvizitarka }"> 
      <label  class="form-label">Kartvizit Arka</label> 
        <picture-input 
          ref="profil"
          width="600" 
          height="200" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Kartvizit Arka Görsel</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="kartvizitarkaDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.kartvizitarka" class="error">{{ formHatalar.kartvizitarka }}</span>
   
    
    
    

     
    </div>

    


 

    <div class="d-flex justify-content-around  mt-4"> 
      
      <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
      <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
    </div>
  </form>

</template>

<script>
import axiosCustom from "@/services/axiosCustom";

import vSelect from "vue-select";




import PictureInput from 'vue-picture-input'





export default {
components: {
  
      vSelect,
  
  
  
    PictureInput,
  
  
  
  
},
props: {
  formIslem: String,
  formData: Object,
  formKaydetSonrasi: Function,
  formIptal: Function,

},
data() {
  return {
    
    gorselSecili: null,
    
    kartvizitonSecili: null,
    
    kartvizitarkaSecili: null,
    
    
  firmalar: [],
  
  
  etkinlikler: [],
  
  

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

    

  };
},
created() {
  
  this.firmalarGetir();
  

  
  this.etkinliklerGetir();
  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

  
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
    },
methods: {
  
  async firmalarGetir() {
    try {
      const response = await axiosCustom.get("firmalar"); 
      this.firmalar = response.data;
    } catch (error) {
      console.error("firmalar alma hatası: ", error);
    }
  },
  

  
  async etkinliklerGetir() {
    try {
      const response = await axiosCustom.get("etkinlikler"); 
      this.etkinlikler = response.data;
    } catch (error) {
      console.error("etkinlikler alma hatası: ", error);
    }
  },
  
  



  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    
    
    if (!this.localFormData.adsoyad) {
      this.formHatalar.adsoyad = "Ad Soyad boş bırakılamaz.";
      kontrol=false;
    }
    

  
  if (!this.localFormData.firma) {
      this.formHatalar.firma = "Firma boş bırakılamaz.";
      kontrol=false;
    }
    



    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();
  newFormData.append("adsoyad", this.localFormData.adsoyad ?? '');
  newFormData.append("telefon", this.localFormData.telefon ?? '');
  newFormData.append("email", this.localFormData.email ?? '');
  newFormData.append("adres", this.localFormData.adres ?? '');
  newFormData.append("not", this.localFormData.not ?? '');
  newFormData.append("gorev", this.localFormData.gorev ?? '');
  newFormData.append("dil", this.localFormData.dil ?? '');
  newFormData.append("firma", this.localFormData.firma ?? '');
  newFormData.append("etkinlik", this.localFormData.etkinlik ?? '');
  newFormData.append("gorsel",  this.gorselSecili);
  newFormData.append("kartviziton",  this.kartvizitonSecili);
  newFormData.append("kartvizitarka",  this.kartvizitarkaSecili);
  

  try {
  if (this.formIslem === "duzenle") {
    axiosCustom
      .post("kisiler/duzenle/" + this.localFormData.id, newFormData)
      .then(() => {
        

        this.$toast.success("Kişi Düzenlendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Güncelleme hatası: ", error);
        this.$toast.error("Güncelleme hatası");
      });
  } else {
    axiosCustom
      .post("kisiler/ekle", newFormData)
      .then(() => {
        

        this.$toast.success("Yeni Kişi Eklendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  }
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  

  
  gorselDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.gorselSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.gorselSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.gorselOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.gorselSecili);
        }
    },
    
  kartvizitonDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitonSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.kartvizitonSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitonOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitonSecili);
        }
    },
    
  kartvizitarkaDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitarkaSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.kartvizitarkaSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitarkaOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitarkaSecili);
        }
    },
    
},
};
</script>